<!-- add-to-list-modal.component.html -->
<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <h2 class="modal-title">Adicionar à lista</h2>
      <button class="close-button" (click)="onClose()" aria-label="Fechar">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Content -->
    <div class="modal-body">
      <!-- Create New List Button -->
      <button type="button" class="create-new-list-btn" (click)="onCreateNewList()">
        <div class="plus-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </div>
        <span>{{'criar_nova_lista' | transloco}}</span>
      </button>

      <!-- Lists -->
      <div class="lists-container">
        <div class="list-item" *ngFor="let list of lists" (click)="toggleSelection(list?.id)">
          <div class="list-icon" *ngIf="!list?.icon || list.icon?.length < 10; else imageIcon">{{list?.icon || '♡'}}
          </div>
          <ng-template #imageIcon>
            <div class="list-icon">
              <img [src]="list.icon" alt="list.name">
            </div>
          </ng-template>

          <div class="list-info">
            <div class="list-name">{{ list.name }}</div>
            <div class="list-description">{{ list.description }}</div>
          </div>
          <div class="checkbox-container">
            <input type="checkbox" [checked]="list.selected" (change)="toggleSelection(list.id)"
              (click)="$event.stopPropagation()">
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="cancel-btn" (click)="onClose()">
        {{'cancelar' | transloco}}
      </button>
      <a href="/minha-conta/favoritos" class="go-to-lists-btn" [routerLink]="'/minha-conta/favoritos'">
        {{'ir_para_listas' | transloco}}
      </a>
      <button type="button" class="confirm-btn" (click)="onConfirm()" [disabled]="getSelectedCount() === 0">
        {{'confirmar' | transloco}}
      </button>
    </div>
  </div>
</div>
